export default "__VITE_ASSET__DaSIUl4X__"